import { Breadcrumb, Button, Card, Checkbox, Layout, notification, Popconfirm, Select, Tooltip } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
const { Option } = Select;

import { deleteCompaniesData, getCompanies } from '../../../redux/actions/API/users';
import Loader from '../../../Home/Loader/Loader';
import { useDispatch } from 'react-redux';

interface IDeleteCompanyDataProps {
    getCompanies: Function;
    companiesData: any;
    deleteCompaniesData: Function;
    deleteCompaniesDataLoading: boolean;
    deleteCompaniesDataMsg: string;

}

const DeleteCompanyData: React.FC<IDeleteCompanyDataProps> = ({
    getCompanies, companiesData,
    deleteCompaniesData, deleteCompaniesDataLoading, deleteCompaniesDataMsg
}) => {

    const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
    const [selectedOptions, setSelectedOptions] = useState<any>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        getCompanies({});
    }, []);

    useEffect(() => {
        if (deleteCompaniesDataMsg) {
            notification.open({ type: 'success', duration: 3, message: 'Selected company data deleted successfully.' });
            dispatch({
                type: 'DELETE_COMPANIES_DATA_SUCCESS', payload: {
                    responseData: { message: '' }
                }
            });
            setSelectedCompany(null);
            setSelectedOptions([]);
        }
    }, [deleteCompaniesDataMsg]);

    const handleDelete = () => {
        const payload = {
            companyId: selectedCompany,
            dataToDelete: selectedOptions
        };
        deleteCompaniesData(payload);
    }


    return (
        <Layout className="layout">
            <Loader loading={deleteCompaniesDataLoading} />
            <Breadcrumb
                style={{ marginBottom: 16 }}
                items={[
                    { title: "Dashboard" },
                    { title: "Delete Company Data" }
                ]}
            />

            <Content className="content-section">
                <Card
                    title="Delete Company Data"
                    bordered={false}
                >
                    {/* Company Select */}
                    <div style={{ marginBottom: 20 }}>
                        <Select
                            showSearch
                            placeholder="Select Company"
                            value={selectedCompany}
                            onChange={(value) => setSelectedCompany(value)}
                            style={{ width: "300px", marginTop: 8 }}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                                option?.children
                                    ?.toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {Array.isArray(companiesData) &&
                                companiesData.map((company: any) => (
                                    <Option key={company.id} value={company.companyId}>
                                        {company.companyName}
                                    </Option>
                                ))}
                        </Select>
                    </div>

                    {/* Options */}

                    <div>
                        <label style={{ fontWeight: 500 }}>Select Data to Delete</label>

                        <Checkbox.Group
                            value={selectedOptions}
                            onChange={(checkedValues) => setSelectedOptions(checkedValues)}
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: 12,
                                marginTop: 12
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="sales">
                                    Sales Documents
                                </Checkbox>
                                <Tooltip title="Deletes All Sales Documents.">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="purchase">Purchase Documents</Checkbox>
                                <Tooltip title="Deletes All Purchase Documents.">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="serviceOrder">Service Order Documents</Checkbox>
                                <Tooltip title="Deletes All Service Order Documents">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="serviceConfirmation">Service Confirmation Documents</Checkbox>
                                <Tooltip title="Deletes All Service confirmation Documents">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="items">Inventory Items</Checkbox>
                                <Tooltip title="Deletes All Items, Store Items, Stock Transfer History, Documents and Boms">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="store">Stores</Checkbox>
                                <Tooltip title="Deletes All Store, Store Items and Stock Transfer Data.">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="storeitem">Store Items / Transfer</Checkbox>
                                <Tooltip title="Deletes Store Items & Stock transfer history.">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="production">Productions</Checkbox>
                                <Tooltip title="Deletes production and bulk production records">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Checkbox value="bom">BOM</Checkbox>
                                <Tooltip title="Deletes bill of materials data">
                                    <InfoCircleOutlined
                                        style={{ color: "#8c8c8c", cursor: "pointer" }}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Tooltip>
                            </div>

                        </Checkbox.Group>
                    </div>



                    <div style={{ marginTop: 24, textAlign: "right" }}>
                        <Popconfirm
                            title="Are you sure?"
                            description="This action will permanently delete the selected company data."
                            okText="Yes, Delete"
                            cancelText="Cancel"
                            okButtonProps={{ danger: true }}
                            onConfirm={() => handleDelete()}
                            overlayStyle={{ width: 320 }}
                        >
                            <Button
                                type="primary"
                                danger
                                style={{ marginTop: 20 }}
                                disabled={!selectedCompany || selectedOptions.length === 0}
                            >
                                Delete Selected Data
                            </Button>
                        </Popconfirm>

                    </div>
                </Card>
            </Content>
        </Layout>

    )
}

const mapStateToProps = (state: any) => ({
    companiesData: state.api.getCompanies?.data,
    deleteCompaniesDataMsg: state.api.deleteCompaniesData?.data,
    deleteCompaniesDataLoading: state.api.deleteCompaniesData?.loading
});

const mapDispatchToProps = (dispatch: any) => ({
    getCompanies: (payload: any) => dispatch(getCompanies(payload)),
    deleteCompaniesData: (payload: any) => dispatch(deleteCompaniesData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCompanyData);
